export { StringTransform as default } from '@ember-data/serializer/-private';
